module.exports = __webpack_public_path__ + "static/img/dlogo.d539c3c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/dlogo.png
// module id = LwjX
// module chunks = 12